import { Icon, Popover, ResourceItem, ResourceList, Spinner, Text } from "@shopify/polaris";
import React, { useCallback, useState } from "react";
import { PromoteFilledMinor, PromoteMinor } from "@shopify/polaris-icons";
import { MerchantAnnouncement, useMerchantAnnouncementListQuery } from "src/graphql/codegen_graphql";
import moment from "moment";

export function AnonouncementMenuMarkup() {
  const [open, setOpen] = useState(false);
  const toggleOpen = useCallback(() => setOpen(!open), [open]);
  const { data, loading } = useMerchantAnnouncementListQuery({
    variables: {
      offset: 0,
      limit: 10,
    },
  });

  const activator = (
    <div className="Polaris-TopBar-Menu__ActivatorWrapper">
      <div
        onClick={toggleOpen}
        style={{ display: "flex", position: "relative", fontSize: "14pt", alignItems: "center" }}
        className="Polaris-TopBar-Menu__Activator"
      >
        {loading ? (
          <Spinner accessibilityLabel="Small spinner example" size="small" />
        ) : (
          <Icon source={PromoteMinor as any} />
        )}
        {data &&
          (data.merchantAnnouncementList || []).filter((item: any) => {
            const created = moment(item.createdAt ? new Date(item.createdAt) : new Date());
            const now = moment(new Date());
            const diff = now.diff(created, "days");

            return diff <= 30;
          }).length > 0 && (
            <span
              style={{
                position: "absolute",
                top: -15,
                zIndex: 100,
                right: -10,
              }}
            >
              <span
                style={{
                  padding: "2px 6px",
                  backgroundColor: "red",
                  color: "white",
                  borderRadius: "0.5rem",
                  fontSize: "10pt",
                }}
              >
                {data.merchantAnnouncementList?.filter((item: any) => {
                  const created = moment(item.createdAt ? new Date(item.createdAt) : new Date());
                  const now = moment(new Date());
                  const diff = now.diff(created, "days");

                  return diff <= 30;
                }).length || 0}
              </span>
            </span>
          )}
      </div>
    </div>
  );

  return (
    <Popover active={open} onClose={toggleOpen} activator={activator}>
      {data && (
        <Popover.Pane>
          <ResourceList
            items={data.merchantAnnouncementList as any}
            renderItem={(item: MerchantAnnouncement) => {
              const created = moment(item.createdAt ? new Date(item.createdAt) : new Date());
              const now = moment(new Date());
              const diff = now.diff(created, "days");
              return (
                <ResourceItem key={item.id || 0} id={item.id + ""} onClick={() => {}}>
                  <h3 style={{ fontFamily: "Hanuman", display: "flex" }}>
                    {diff <= 30 && (
                      <div style={{ width: 30 }}>
                        <Icon tone="critical" source={PromoteFilledMinor as any} />
                      </div>
                    )}
                    <Text variant="bodySm" fontWeight="bold" as="h3">
                      {item.title}
                    </Text>
                  </h3>
                  <small>{item.contentInMarkdown}</small>
                </ResourceItem>
              );
            }}
          />
        </Popover.Pane>
      )}
    </Popover>
  );
}
